module.exports = __webpack_public_path__ + "static/media/drumRollHit.fe80defa.mp3";